import { render, staticRenderFns } from "./erweima.vue?vue&type=template&id=4cce884e&scoped=true&"
import script from "./erweima.vue?vue&type=script&lang=js&"
export * from "./erweima.vue?vue&type=script&lang=js&"
import style0 from "./erweima.vue?vue&type=style&index=0&id=4cce884e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce884e",
  null
  
)

export default component.exports